import dynamic from 'next/dynamic';
const CookieBlocker = dynamic(() => import('./CookieBlocker'));

export default CookieBlocker;
